import * as React from 'react';
import { useI18n } from '@goparrot-dashboard/i18n';
import { MarketButton } from '@market/react-bindings';
import { useSsoLoginWithHandlers } from '../hooks/useSsoLoginWithHandlers';

export const SsoSignInButton: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { getIntlString } = useI18n();

  const ssoLogin = useSsoLoginWithHandlers();

  const handleClick = () => ssoLogin.mutate({});

  return (
    <MarketButton className="tw-bg-black" onClick={handleClick} rank="primary" size="medium" role="button" data-testid="sign-in-with-square-button">
      {getIntlString('button.ssoSignIn')}
    </MarketButton>
  );
};
